import React from 'react';

import TextField from 'material-ui/TextField';
import { FormHelperText } from 'material-ui/Form';

const errorText = {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
};

const renderTextFieldWithDiv = ({ input, label, className, divClassName, password, disabled, meta: { touched, error }, ...custom }) => {
    return (
    <div className={divClassName}>
        <TextField
            label={label}
            error={(touched && error && error !== '')}
            type={password ? 'password' : 'text'}
            disabled={disabled}
            className={className}
            {...input}
            {...custom}
        />
        {
            touched && error &&
            <FormHelperText style={errorText}>{error}</FormHelperText>
        }
    </div>
)};

export default renderTextFieldWithDiv;


// WEBPACK FOOTER //
// ./src/helpers/RenderTextFiledWithDiv.js